import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import { useEffect } from "react";
import CustomButton from "./CustomButton";

export default function ConfirmDialog({
    open,
    setOpen,
    title,
    message,
    targetName,
    targetId,
    callback,
    warningAlert,
    extraContent,
    okText = "Yes",
    cancelText = "No",
}) {
    const handleClose = (e) => {
        setOpen(false);

        // Logger.log("targetId:" + targetId + ", value:" + e.target.value);
        if (e.target.value === okText) {
            // Logger.log(`callback(${targetId})`);
            callback(targetId);
        }
    };

    useEffect(() => {
        // do nothing
    }, []);

    return (
        <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" maxWidth="sm" fullWidth>
            <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
            <DialogContent>
                {targetName && (
                    <div style={{ marginBottom: 10, wordBreak: "break-all", wordWrap: "break-word" }}>
                        <center>
                            <b>{targetName}</b>
                        </center>
                    </div>
                )}
                {message && (
                    <Box id="alert-dialog-description" component="div" sx={{ color: 'text.secondary' }}>
                        {Array.isArray(message) ? (
                            message.map((line, index) => (
                                <div key={index} style={{ marginBottom: index < message.length - 1 ? '8px' : '0' }}>
                                    {line}
                                </div>
                            ))
                        ) : (
                            <div style={{ whiteSpace: 'normal', overflow: 'visible', wordBreak: 'break-word' }}>
                                {message}
                            </div>
                        )}
                    </Box>
                )}
                {warningAlert && (
                    <Alert severity="warning" sx={{ mt: 2 }}>
                        {warningAlert}
                    </Alert>
                )}
                {extraContent}
            </DialogContent>
            <DialogActions style={{ display: "flex", justifyContent: "space-between", m: 2 }}>
                <CustomButton value={okText} variant={"contained"} onClick={handleClose} color="primary">
                    {okText}
                </CustomButton>
                <CustomButton value={cancelText} variant={"contained"} onClick={handleClose} color="secondary" autoFocus>
                    {cancelText}
                </CustomButton>
            </DialogActions>
        </Dialog>
    );
}
